import { render, staticRenderFns } from "./GebrauchtwagenCockpit.vue?vue&type=template&id=5f633784&scoped=true&slot=header&"
import script from "./GebrauchtwagenCockpit.vue?vue&type=script&lang=js&"
export * from "./GebrauchtwagenCockpit.vue?vue&type=script&lang=js&"
import style0 from "./GebrauchtwagenCockpit.vue?vue&type=style&index=0&id=5f633784&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f633784",
  null
  
)

export default component.exports